import { Checkbox } from '@mui/material';
import { OldAutocompleteRenderOptionState } from '../../../adaptersMui/AutocompleteMuiAdapter/autocompleteMuiAdapter.types';

type RenderDefaultOptionsProps<T> = {
  option: T;
  state: OldAutocompleteRenderOptionState;
  getOptionLabel: (option: any) => string;
  checkbox?: boolean;
  renderOption?: (option: any, state: OldAutocompleteRenderOptionState) => React.ReactNode;
};

const renderDefaultOptions = <T,>({
  option,
  state,
  checkbox,
  renderOption,
  getOptionLabel,
}: RenderDefaultOptionsProps<T>) => {
  return (
    <>
      {checkbox && (
        <Checkbox
          color="primary"
          sx={{ marginRight: '8px', width: '30px', height: '30px', marginLeft: '-8px' }}
          checked={state.selected}
          size="small"
        />
      )}
      {renderOption ? renderOption(option, state) : getOptionLabel(option)}
    </>
  );
};

export default renderDefaultOptions;
